/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { APIException } from '../model';
// @ts-ignore
import { BookingDataRequestDeclinePublic } from '../model';
// @ts-ignore
import { BookingDataRequestPublic } from '../model';
// @ts-ignore
import { BookingDataRequestSubmitPublic } from '../model';
// @ts-ignore
import { DataRequestSubmittedPublic } from '../model';
// @ts-ignore
import { ValidationError } from '../model';
/**
 * PublicBookingDataRequestApi - axios parameter creator
 * @export
 */
export const PublicBookingDataRequestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Declines a Booking Data Request.
         * @param {string} dataRequestId 
         * @param {BookingDataRequestDeclinePublic} [bookingDataRequestDeclinePublic] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingDataRequestDeclineCreate: async (dataRequestId: string, bookingDataRequestDeclinePublic?: BookingDataRequestDeclinePublic, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataRequestId' is not null or undefined
            assertParamExists('publicBookingDataRequestDeclineCreate', 'dataRequestId', dataRequestId)
            const localVarPath = `/v2/public/booking/data-request/{data_request_id}/decline`
                .replace(`{${"data_request_id"}}`, encodeURIComponent(String(dataRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingDataRequestDeclinePublic, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch the public information about the Booking Data Request
         * @param {string} dataRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingDataRequestRetrieve: async (dataRequestId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataRequestId' is not null or undefined
            assertParamExists('publicBookingDataRequestRetrieve', 'dataRequestId', dataRequestId)
            const localVarPath = `/v2/public/booking/data-request/{data_request_id}`
                .replace(`{${"data_request_id"}}`, encodeURIComponent(String(dataRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A submission can only occur when the DataRequest is the latest for the Booking and the status of the DataRequest is OPEN. If theres any issue when submitting the DataRequest the message for why will be returned in the `detail` key in the body.  The returned content will be a link to open the users SMS app with the recipient being the Data Request owner and the content from the `booking_data_request_completed_sms` template. 
         * @summary Submits the Booking Data Request
         * @param {string} dataRequestId 
         * @param {BookingDataRequestSubmitPublic} bookingDataRequestSubmitPublic 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingDataRequestSubmitCreate: async (dataRequestId: string, bookingDataRequestSubmitPublic: BookingDataRequestSubmitPublic, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataRequestId' is not null or undefined
            assertParamExists('publicBookingDataRequestSubmitCreate', 'dataRequestId', dataRequestId)
            // verify required parameter 'bookingDataRequestSubmitPublic' is not null or undefined
            assertParamExists('publicBookingDataRequestSubmitCreate', 'bookingDataRequestSubmitPublic', bookingDataRequestSubmitPublic)
            const localVarPath = `/v2/public/booking/data-request/{data_request_id}/submit`
                .replace(`{${"data_request_id"}}`, encodeURIComponent(String(dataRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingDataRequestSubmitPublic, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicBookingDataRequestApi - functional programming interface
 * @export
 */
export const PublicBookingDataRequestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicBookingDataRequestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Declines a Booking Data Request.
         * @param {string} dataRequestId 
         * @param {BookingDataRequestDeclinePublic} [bookingDataRequestDeclinePublic] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicBookingDataRequestDeclineCreate(dataRequestId: string, bookingDataRequestDeclinePublic?: BookingDataRequestDeclinePublic, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingDataRequestPublic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicBookingDataRequestDeclineCreate(dataRequestId, bookingDataRequestDeclinePublic, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Fetch the public information about the Booking Data Request
         * @param {string} dataRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicBookingDataRequestRetrieve(dataRequestId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingDataRequestPublic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicBookingDataRequestRetrieve(dataRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * A submission can only occur when the DataRequest is the latest for the Booking and the status of the DataRequest is OPEN. If theres any issue when submitting the DataRequest the message for why will be returned in the `detail` key in the body.  The returned content will be a link to open the users SMS app with the recipient being the Data Request owner and the content from the `booking_data_request_completed_sms` template. 
         * @summary Submits the Booking Data Request
         * @param {string} dataRequestId 
         * @param {BookingDataRequestSubmitPublic} bookingDataRequestSubmitPublic 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicBookingDataRequestSubmitCreate(dataRequestId: string, bookingDataRequestSubmitPublic: BookingDataRequestSubmitPublic, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataRequestSubmittedPublic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicBookingDataRequestSubmitCreate(dataRequestId, bookingDataRequestSubmitPublic, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicBookingDataRequestApi - factory interface
 * @export
 */
export const PublicBookingDataRequestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicBookingDataRequestApiFp(configuration)
    return {
        /**
         * 
         * @summary Declines a Booking Data Request.
         * @param {string} dataRequestId 
         * @param {BookingDataRequestDeclinePublic} [bookingDataRequestDeclinePublic] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingDataRequestDeclineCreate(dataRequestId: string, bookingDataRequestDeclinePublic?: BookingDataRequestDeclinePublic, options?: any): AxiosPromise<BookingDataRequestPublic> {
            return localVarFp.publicBookingDataRequestDeclineCreate(dataRequestId, bookingDataRequestDeclinePublic, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch the public information about the Booking Data Request
         * @param {string} dataRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingDataRequestRetrieve(dataRequestId: string, options?: any): AxiosPromise<BookingDataRequestPublic> {
            return localVarFp.publicBookingDataRequestRetrieve(dataRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * A submission can only occur when the DataRequest is the latest for the Booking and the status of the DataRequest is OPEN. If theres any issue when submitting the DataRequest the message for why will be returned in the `detail` key in the body.  The returned content will be a link to open the users SMS app with the recipient being the Data Request owner and the content from the `booking_data_request_completed_sms` template. 
         * @summary Submits the Booking Data Request
         * @param {string} dataRequestId 
         * @param {BookingDataRequestSubmitPublic} bookingDataRequestSubmitPublic 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingDataRequestSubmitCreate(dataRequestId: string, bookingDataRequestSubmitPublic: BookingDataRequestSubmitPublic, options?: any): AxiosPromise<DataRequestSubmittedPublic> {
            return localVarFp.publicBookingDataRequestSubmitCreate(dataRequestId, bookingDataRequestSubmitPublic, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for publicBookingDataRequestDeclineCreate operation in PublicBookingDataRequestApi.
 * @export
 * @interface PublicBookingDataRequestApiPublicBookingDataRequestDeclineCreateRequest
 */
export interface PublicBookingDataRequestApiPublicBookingDataRequestDeclineCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestDeclineCreate
     */
    readonly dataRequestId: string

    /**
     * 
     * @type {BookingDataRequestDeclinePublic}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestDeclineCreate
     */
    readonly bookingDataRequestDeclinePublic?: BookingDataRequestDeclinePublic
}

/**
 * Request parameters for publicBookingDataRequestRetrieve operation in PublicBookingDataRequestApi.
 * @export
 * @interface PublicBookingDataRequestApiPublicBookingDataRequestRetrieveRequest
 */
export interface PublicBookingDataRequestApiPublicBookingDataRequestRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestRetrieve
     */
    readonly dataRequestId: string
}

/**
 * Request parameters for publicBookingDataRequestSubmitCreate operation in PublicBookingDataRequestApi.
 * @export
 * @interface PublicBookingDataRequestApiPublicBookingDataRequestSubmitCreateRequest
 */
export interface PublicBookingDataRequestApiPublicBookingDataRequestSubmitCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestSubmitCreate
     */
    readonly dataRequestId: string

    /**
     * 
     * @type {BookingDataRequestSubmitPublic}
     * @memberof PublicBookingDataRequestApiPublicBookingDataRequestSubmitCreate
     */
    readonly bookingDataRequestSubmitPublic: BookingDataRequestSubmitPublic
}

/**
 * PublicBookingDataRequestApi - object-oriented interface
 * @export
 * @class PublicBookingDataRequestApi
 * @extends {BaseAPI}
 */
export class PublicBookingDataRequestApi extends BaseAPI {
    /**
     * 
     * @summary Declines a Booking Data Request.
     * @param {PublicBookingDataRequestApiPublicBookingDataRequestDeclineCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicBookingDataRequestApi
     */
    public publicBookingDataRequestDeclineCreate(requestParameters: PublicBookingDataRequestApiPublicBookingDataRequestDeclineCreateRequest, options?: any) {
        return PublicBookingDataRequestApiFp(this.configuration).publicBookingDataRequestDeclineCreate(requestParameters.dataRequestId, requestParameters.bookingDataRequestDeclinePublic, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch the public information about the Booking Data Request
     * @param {PublicBookingDataRequestApiPublicBookingDataRequestRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicBookingDataRequestApi
     */
    public publicBookingDataRequestRetrieve(requestParameters: PublicBookingDataRequestApiPublicBookingDataRequestRetrieveRequest, options?: any) {
        return PublicBookingDataRequestApiFp(this.configuration).publicBookingDataRequestRetrieve(requestParameters.dataRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A submission can only occur when the DataRequest is the latest for the Booking and the status of the DataRequest is OPEN. If theres any issue when submitting the DataRequest the message for why will be returned in the `detail` key in the body.  The returned content will be a link to open the users SMS app with the recipient being the Data Request owner and the content from the `booking_data_request_completed_sms` template. 
     * @summary Submits the Booking Data Request
     * @param {PublicBookingDataRequestApiPublicBookingDataRequestSubmitCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicBookingDataRequestApi
     */
    public publicBookingDataRequestSubmitCreate(requestParameters: PublicBookingDataRequestApiPublicBookingDataRequestSubmitCreateRequest, options?: any) {
        return PublicBookingDataRequestApiFp(this.configuration).publicBookingDataRequestSubmitCreate(requestParameters.dataRequestId, requestParameters.bookingDataRequestSubmitPublic, options).then((request) => request(this.axios, this.basePath));
    }
}
